export default __webpack_public_path__ + "40d15ccbd8e95a9e0d6c22514c9f54d5.gif";